import React from 'react';
import { useIntl } from 'react-intl';

import { LoadingWizardScreen } from '@futrli/ui-components/components/sidebar/wizard/screens/loading-wizard-screen/loading-wizard-screen';

export const SwitchRuleLoadingScreen = () => {
  const intl = useIntl();

  return (
    <LoadingWizardScreen
      text={intl.formatMessage({
        id: 'predict.coa.creating_switch_rule',
        defaultMessage: 'Creating switch rule...'
      })}
    />
  );
};
